export default __webpack_public_path__ + "static/media/slider3-2.51dd709f.jpg";